import type {SharedJobRow} from "../../components/scanner/shared-job-scanner/SharedJobData.tsx";

const map: Record<string, string> = {
    "0": "Deprecated: Nully McNullFace",
    "54083576": "Deprecated: Alter External Table",
    "108097929": "Deprecated: Cassandra incremental load",
    "128170095": "Rename",
    "160909237": "Workday Custom Reports",
    "181384252": "Deprecated: OracleEloqua",
    "201630485": "RDS Bulk Output",
    "211954775": "Table Output",
    "231749898": "Snapchat Extract",
    "235671163": "And",
    "237373210": "Truncate Table",
    "242660787": "Deprecated: Assert Variables",
    "248931201": "Deprecated: SendGrid Query",
    "248931332": "SendGrid Query",
    "272836776": "Deprecated: Google Analytics incremental load",
    "290087695": "Construct Variant",
    "293512757": "PayPal Query",
    "307692316": "Open Exchange Rates Query",
    "311151861": "Deprecated: OData Query",
    "311151992": "OData Query",
    "319768247": "Square Query",
    "335239555": "Rewrite Table",
    "356330947": "Table Metadata To Grid",
    "374945314": "S3 Unload",
    "404326196": "SAP ODP Extract",
    "416069678": "Flatten Variant",
    "438858066": "SNS Message",
    "444132438": "Start",
    "467449945": "Salesforce Bulk Query",
    "479776707": "Mixpanel Query",
    "515156205": "End Failure",
    "519458241": "Deprecated: Cassandra Query",
    "520523248": "Assert Scalar Variables",
    "537948966": "Deprecated: Salesforce incremental load V2",
    "573530273": "Zuora Bulk Query",
    "609793074": "Window Calculation",
    "620619864": "Data Transfer",
    "631604974": "JDBC Table Metadata To Grid",
    "640379434": "Deprecated: Postgres incremental load",
    "655623811": "Create File Format",
    "683090754": "Deprecated: Open Exchange Rates Incremental Load",
    "699187412": "Redis Query",
    "716056355": "RDS Query",
    "725525177": "Deprecated: S3 Get Object",
    "738944574": "Fixed Flow",
    "749275927": "Alter External Table",
    "764755612": "Deprecated: S3 Put Object",
    "768364289": "LinkedIn Query",
    "773867971": "S3 Load",
    "791250579": "Deprecated: Dynamics 365 Sales",
    "837770393": "Deprecated: Twitter Query",
    "837770524": "Twitter Query",
    "848219585": "Google Ads Query",
    "857628086": "Recurly Extract",
    "900171429": "Deprecated: LinkedIn Query",
    "930622248": "ServiceNow Query",
    "944477051": "Bing Search Query",
    "947435869": "Mandrill Extract",
    "977205684": "Commit",
    "989533025": "Run DBT Command",
    "1006021671": "Webhook Post",
    "1014376285": "Jira Query",
    "1025378138": "DynamoDB Query",
    "1025742816": "Loop Iterator",
    "1028954362": "Deprecated: Apache Spark SQL Query",
    "1028954493": "Apache Spark SQL Query",
    "1043089869": "API Extract",
    "1058406652": "File Iterator",
    "1083788122": "Pardot Output",
    "1121667926": "Salesforce Query",
    "1139103188": "Pivot",
    "1155583855": "Query Result To Grid",
    "1190001897": "Salesforce Incremental Load",
    "1214167174": "Deprecated: API Query",
    "1214167305": "API Query",
    "1227580116": "Table Iterator",
    "1251156862": "Deprecated: Salesforce incremental load V4",
    "1263570568": "Deprecated: Google Sheets incremental load",
    "1267143635": "Unpivot",
    "1269772069": "Deprecated: JDBC Incremental Load V3",
    "1269789361": "Deprecated: JDBC Incremental Load V4",
    "1354890871": "Table Input",
    "1364466516": "Create External Table",
    "1370964939": "Deprecated: Assert View",
    "1375574157": "Cassandra Query",
    "1395653910": "Facebook Ads Query",
    "1395699082": "Remove From Grid",
    "1419075255": "Zendesk Talk Query",
    "1435881828": "Create Stream",
    "1439414779": "Generate Sequence",
    "1461126543": "Deprecated: Marketo Incremental Load",
    "1497848919": "Mailchimp Query",
    "1499852633": "Deprecated: Zendesk Query",
    "1519899023": "Zuora Query",
    "1523619877": "Deprecated: Shopify Query",
    "1523620008": "Shopify Query",
    "1550077120": "Deprecated: Greenplum CData Query",
    "1566403525": "Show To Grid",
    "1579481267": "Deprecated: Sugar CRM Query",
    "1579481398": "Sugar CRM Query",
    "1611478312": "Create Table",
    "1649909120": "YouTube Analytics Query",
    "1659634638": "Deprecated: QuickBooks Online",
    "1666437395": "Deprecated: JDBC Incremental Load V2",
    "1690243742": "Deprecated: YouTube Query",
    "1701703136": "Aggregate",
    "1711071977": "Deprecated: Facebook AdInsights incremental load",
    "1716658327": "Calculator",
    "1729310018": "LDAP Query",
    "1732594739": "Deprecated: MongoDB incremental load",
    "1744268877": "Distinct",
    "1744823235": "Deprecated: Matillion Test",
    "1763886537": "Dynamics CRM Query",
    "1785813072": "Run Orchestration",
    "1813541343": "Deprecated: Facebook ContentInsights incremental load",
    "1818501068": "Deprecated: Twitter Tweets",
    "1838652813": "Convert Type",
    "1847161714": "HubSpot Query",
    "1860489170": "Fixed Iterator",
    "1882958065": "Deprecated: SAP Hana CData Query",
    "1892276658": "Box Extract",
    "1896325668": "Run Transformation",
    "1897708330": "Deprecated: Excel Query",
    "1897708461": "Excel Query",
    "1897749260": "Instagram Extract",
    "1903979410": "Deprecated: Dynamics NAV Query",
    "1903979541": "Dynamics NAV Query",
    "1912812990": "Intersect",
    "1963777357": "Deprecated: Gmail Query",
    "1963777488": "Gmail Query",
    "1975307829": "Deprecated: IBMDB2 incremental load",
    "1987409085": "Smart Output",
    "1989138124": "Azure Blob Storage Load",
    "1992375629": "Deprecated: Dynamics 365 Query",
    "1998016859": "Zendesk Support Query",
    "2024738184": "Deprecated: MariaDB Incremental Load",
    "2052039210": "Deprecated: S3 Clear Files",
    "2052306058": "SAP NetWeaver Query",
    "2086082344": "CloudWatch Publish",
    "2123812615": "Deprecated: JDBC Incremental Load V1",
    "2139809017": "Rank",
    "-627810085": "Transpose Columns",
    "-1848704949": "Table Update",
    "-2139546284": "Except",
    "-319648201": "Create View",
    "-1266674941": "SQL",
    "-793576480": "Extract Nested Data",
    "-1760161015": "Filter",
    "-2009723820": "Multi Table Input",
    "-359894709": "Detect Changes",
    "-629958239": "Join",
    "-1935486466": "First/Last",
    "-1949249710": "Replicate",
    "-684341771": "Stream Input",
    "-220881549": "Nested Transformation",
    "-1593650416": "Lead/Lag",
    "-434984205": "Transpose Rows",
    "-973819290": "Assert View",
    "-2003079336": "Virtual Input",
    "-1841822228": "Unite",
    "-1844569003": "Split Field",
    "-1": "Deprecated: Unknown Component",
    "-1802397": "Map Values",
    "-875573236": "Alter Table",
    "-1032749985": "Query Result To Scalar",
    "-1123534304": "Oracle Output",
    "-1591282916": "Couchbase Query",
    "-1946388514": "End Success",
    "-44805405": "Dropbox Extract",
    "-1542309371": "Microsoft Exchange Query",
    "-352982706": "Apache Hive Query",
    "-1070416981": "Deprecated: MYSQL incremental load",
    "-1952446707": "Deprecated: BigQuery incremental load",
    "-158614544": "Retry",
    "-53243632": "Deprecated: Check required columns V2",
    "-1222124999": "Deprecated: Salesforce Marketing Cloud Query",
    "-2034943103": "Anaplan Bulk",
    "-1926640548": "Google Sheets Query",
    "-387232669": "Deprecated: DateTime Parameter Tester",
    "-1608038798": "Marketo Query",
    "-1926640679": "Deprecated: Google Sheets Query",
    "-1717419971": "Zendesk Chat Extract",
    "-193159521": "Deprecated: Run Shared Transformation",
    "-1821570638": "QuickBooks Online Query",
    "-804567148": "SurveyMonkey Query",
    "-30576485": "Bash Script",
    "-118425605": "Google Custom Search Query",
    "-1544821124": "Deprecated: Facebook AdAccounts incremental load",
    "-1520054804": "NetSuite Query",
    "-1540940111": "Rollback",
    "-53243763": "Deprecated: Check Source Metadata",
    "-525995223": "Salesforce Output",
    "-856123882": "Intercom Extract",
    "-912336555": "Twitter Ads Query",
    "-1634581590": "Deprecated: Load Target",
    "-1222124868": "Salesforce Marketing Cloud Query",
    "-1654201222": "Deprecated: Salesforce incremental load V3",
    "-205266581": "Email Query",
    "-1481458271": "Deprecated: Mailchimp",
    "-1150776036": "Deprecated: Splunk Query",
    "-1422600676": "Deprecated: Excel incremental load",
    "-952459490": "Send Email",
    "-1286515545": "Sync File Source",
    "-1231910936": "Pardot Extract",
    "-25143249": "Microsoft SQL Server Output",
    "-906249838": "Amplitude Extract",
    "-1773186829": "Python Script",
    "-2083664584": "SharePoint Query",
    "-1251764363": "Cloud Pub/Sub",
    "-1520054935": "Deprecated: NetSuite Query",
    "-1520055066": "Deprecated: NetSuite Query",
    "-272001493": "Deprecated: Oracle incremental load",
    "-1359342524": "Deprecated: HubSpot incremental load",
    "-1304746307": "Deprecated: Zoho CRM Query",
    "-1285515778": "MindSphere Extract",
    "-1407986718": "Deprecated: Facebook Query",
    "-1133267377": "Describe To Grid",
    "-2112089365": "Deprecated: Expressions to Metrics",
    "-369209785": "Append To Grid",
    "-1785670938": "Begin",
    "-735148429": "Azure Blob Storage Unload",
    "-826436385": "Deprecated: Pardot Extract",
    "-1984616750": "Assert External Table",
    "-2110531766": "Deprecated: OData incremental load",
    "-1025498028": "Xero Query",
    "-454427654": "Google Analytics Query",
    "-1357378929": "If",
    "-1343684451": "Or",
    "-610059506": "Deprecated: Google AdWords Query",
    "-568104212": "Cloud Storage Load",
    "-1455335334": "Oracle Eloqua Query",
    "-1567154010": "Magento Query",
    "-1773186960": "Deprecated: Python Script",
    "-192064813": "Twilio Query",
    "-135001008": "Elasticsearch Query",
    "-1858913064": "Deprecated: Bing Search",
    "-1244571512": "Deprecated: Google AdWords incremental load",
    "-1677869191": "Dynamics 365 Query",
    "-425919817": "Bing Ads Query",
    "-31479654": "Google Ad Manager Query",
    "-113659674": "Alter Masking Policy",
    "-424773870": "Grid Iterator",
    "-213544349": "Deprecated: Jira incremental load",
    "-2019923301": "Stripe Query",
    "-1325292042": "LinkedIn Ads Query",
    "-535394805": "Cloud Storage Unload",
    "-166675064": "Deprecated: Elastic Search incremental load",
    "-547809127": "Assign Tag",
    "-1150775905": "Splunk Query",
    "-1859466705": "Alter Warehouse",
    "-424886696": "Azure Cosmos Query",
    "-1211855512": "Refresh External Table",
    "-714034892": "Deprecated: NetSuite incremental load",
    "-798585337": "SQL Script",
    "-560018399": "Facebook Query",
    "-377483579": "Assert Table",
    "-352982837": "Deprecated: Apache Hive Query",
    "-1180878087": "Deprecated: Run Shared Orchestration",
    "-1976291686": "Workday Extract",
    "-619120903": "Deprecated: MSSQL incremental load",
    "-159239741": "SQS Message",
    "-1572329038": "Deprecated: SurveyMonkey",
    "-741198691": "Database Query",
    "-1304746176": "Zoho CRM Query",
    "-732645333": "Deprecated: Assert Parameter Values",
    "-1291941950": "Delete Tables",
    "-1814463242": "Deprecated: Dynamics 365 Business Central Query",
    "-1875943255": "Dynamics 365 Sales Query",
    "-1144339613": "Deprecated: Sage Intacct",
    "-1222231987": "Intercom Output",
    "-1562779777": "Deprecated: Assert Table",
    "-1814463111": "Dynamics 365 Business Central Query",
    "-1504384752": "Sage Intacct Query",
    "-1984790406": "S3 Load Generator",
    "-30576616": "Deprecated: Bash Script",
    "-888888192": "Google BigQuery",
    "-962549893": "JDBC Incremental Load",
    "-1186667461": "MongoDB Query"
}

export function sharedJobName(row: SharedJobRow): string {
    return `${row.packageName}.${row.jobName}.v${row.revision}`
}

export function implementationName(implementationId: number, sharedJobs?: SharedJobRow[]): string {
    if(implementationId === -1) return "Unknown component"
    const mapEntry = map[implementationId]
    if(mapEntry) return mapEntry
    if(sharedJobs) {
        const sharedJob = sharedJobs.find(job => job.implementationId === implementationId)
        if(sharedJob) return `${sharedJob.packageName}.${sharedJob.jobName}.v${sharedJob.revision}`
    }

    // Fallback to implementationId if no name is found
    return "Unknown - " + implementationId;
}